const galleryData = [
  {
    title: "Splash & Bond: Fun Times at Club Cabana",
    image: "images/experience/fun_day_at_leica.webp",
    description: "visited Club Cabana, a fun-filled resort with exciting water activities. We played Leica Mates in the pool, making unforgettable memories with friends and laughter.",
    category: "Community",
    date: "23-May-2024"
  },
  {
    title: "Observing Live Microsurgery",
    image: "images/experience/hospital_visit2.webp",
    description: "At Sri Sathya Sai Hospital, I observed a live microsurgery session. It was incredibly fulfilling to see my code actively contributing to real-world medical procedures.",
    category: "Work Environment",
    date: "06-June-2022",
    imageOffsetY: 0
  },
  {
    title: "Hospital visit from Leica",
    image: "images/experience/hospital_visit1.webp",
    description: "Visited Sri Sathya Sai Hospital to witness a live surgery using a microscope. It was a proud moment to see the code I wrote being used to help save lives.",
    category: "Work Environment",
    date: "06-June-2022",
    imageOffsetY: 0
  },
  {
    title: "Student Demonstration",
    image: "images/experience/demonstrating_microscopes_to_kids.webp",
    description: "Demonstrating students how surgical microscopes work.",
    category: "Community",
    date: "27-Apr-2023"
  },
  {
    title: "Team Retreat",
    image: "images/experience/when_colegues_become_besties.webp",
    description: "Team outing to resort with leica team-mates.",
    category: "Team Event",
    date: "06-Jan-2023"
  },
  {
    title: "Team Reunion",
    image: "images/experience/lunch_with_collegues_at_leica.webp",
    description: "Lunch with colleagues after COVID.",
    category: "Team Event",
    date: "01-Oct-2021"
  },
  {
    title: "Team Farewell",
    image: "images/experience/leica_prior_to_sendoff.webp",
    description: "Saying goodbye to colleagues at Leica Microsystems.",
    category: "Team Event",
    date: "14-Jun-2024"
  },
  {
    title: "Team Offsite",
    image: "images/experience/outing_from_ibm.webp",
    description: "Team activities with IBM team.",
    category: "Team Event",
    date: "04-Jul-2024"
  },
  {
    title: "AI Conference",
    image: "images/experience/ibm_watson_push.webp",
    description: "Attending an event on industrial applications of AI.",
    category: "Conference",
    date: "11-Jul-2024"
  },
  {
    title: "Workstation",
    image: "images/experience/my_workplace_lieca.webp",
    description: "My workspace at Leica Microsystems.",
    category: "Work Environment",
    date: "06-Dec-2023"
  },
  {
    title: "Hackathon Preparation",
    image: "images/experience/leica_ai_on_microscope.webp",
    description: "Working on our entry for an innovation challenge.",
    category: "Team Project",
    date: "20-Aug-2023"
  },
  {
    title: "Technology Symposium",
    image: "images/experience/attending_wintecon.webp",
    description: "Attending conference on future wireless technologies.",
    category: "Conference",
    date: "11-Nov-2024"
  },
  {
    title: "Data collection for video stabilization",
    image: "images/experience/leica_video_stabilization_ideation.webp",
    description: "Brainstorming video stabilization techniques.",
    category: "Team Project",
    date: "22-Nov-2022"
  },
  {
    title: "Thermostat Testing System",
    image: 'images/experience/test_system_view.webp',
    description: "Working on the test bench for thermostat quality control systems.",
    category: "Work Project",
    date: "23-Jul-2013"
  },
  {
    title: "On-Site Installation",
    image: "images/experience/me_at_invensys_site.webp",
    description: "Setting up testing equipment at a client's facility.",
    category: "Work Project",
    date: "23-Jul-2013",
    imageOffsetY: 0
  },
  {
    title: "Husco Factory Visit",
    image: "images/experience/husco_system.webp",
    description: "Touring the hydraulic valve production line.",
    category: "Work Visit",
    date: "23-Jul-2013"
  }
];

export default galleryData;